import React from "react";
import { v4 as uuid } from "uuid";
import { Text } from "../Text";
import { Title } from "../Title";
import { PricingTableProps } from "./index";
import { Table } from "../Table";
import { Th } from "../Table/_/Th";
import { Td } from "../Table/_/Td";
import { Tr } from "../Table/_/Tr";

export const PricingTable: React.FC<PricingTableProps> = ({ title, subtitle, columnHeader, rows, footer }) => {
  return (
    <>
      {title && <Title as="h2">{title}</Title>}
      {subtitle && <Text mb={4} mt="24px" dangerouslySetInnerHTML={{ __html: subtitle }} />}
      <Table width={["100%", "100%", "100%", "100%", "500px"]} data-testid="pricing-table">
        <Tr data-testid="row-title">
          {columnHeader.map((c, index) => (
            <Th data-testid="column-header" key={c} pb={3} textAlign="left">
              <Title
                pl={index === 1 ? [3, 4, 4, 4] : 0}
                pr={index === 0 ? 4 : [0, 0, 4, 4]}
                as="h4"
                fontSize={["16px", "24px", "24px", "24px"]}
              >
                {c}
              </Title>
            </Th>
          ))}
        </Tr>
        {rows.map(r => (
          // Key not relevant for static content - used to supress warnings.
          <Tr key={uuid()} data-testid="row-data">
            {r.map((d, index) => (
              <Td key={d} p={0} textAlign="left">
                <Text pl={index === 1 ? [3, 4, 4, 4] : 0}>{d}</Text>
              </Td>
            ))}
          </Tr>
        ))}
      </Table>
      <Text dangerouslySetInnerHTML={{ __html: footer }} />
    </>
  );
};
